// Configuration for Client Management API
export const CATALOGS_INDEX = 'v1/catalogs';
export const CATALOGS_ORGANIZATION_TYPES = 'v1/catalogs/organizationTypes';
export const CATALOGS_ARCHETYPES = 'v1/catalogs/archetypes';
export const CATALOGS_DATALINK_TYPES = 'v1/catalogs/dataLinkTypes';
export const CATALOGS_SUBSCRIPTION_TYPES = 'v1/catalogs/subscriptionTypes';
export const CATALOGS_ORGANIZATION_CATEGORIES =
  'v1/catalogs/organizationCategories';
